// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="valutazione">
            <div className="bg-valuta bg-overlay-black-20 space-ptb">
                <div className="container-fluid w-special">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-12">
                            <p className="sub-title">{t('homePage.sellBanner.subTitle')}</p>
                            <h2 className="mb-5">{t('homePage.sellBanner.title')}</h2>
                        </div>
                        <div className="col-12 col-lg-7">
                            <p className="mb-4 mb-lg-0" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
                        </div>
                        <div className="col-12 col-lg-4 text-center">
                            <Link className="btn btn-primary" to="/valutazione">
                                <span>{t('homePage.sellBanner.btnText')}</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerVendi;